import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Card, CardContent, H5, H6 } from "@sellar-io/components";

export const IntegrationCard = ({
  appImage,
  title,
  description,
  headerAction,
  children,
  actions,
  className,
}: {
  appImage?: string;
  title: string;
  description: ReactNode;
  headerAction?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) => {
  return (
    <Card
      className={twMerge("h-full border border-zinc-200 bg-white", className)}
    >
      <CardContent className="flex h-full flex-col gap-3 p-4">
        {appImage ? (
          <>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <img
                alt={title}
                src={appImage}
                className="h-12 w-12 rounded-lg object-contain"
              />
              {headerAction}
            </div>
            <div className="flex min-w-0 flex-col">
              <H5>{title}</H5>
              <H6>{description}</H6>
            </div>
          </>
        ) : (
          <div className="flex flex-col gap-1">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <H5>{title}</H5>
              {headerAction}
            </div>
            <H6>{description}</H6>
          </div>
        )}
        {children}
        {actions ? (
          <div className="mt-auto flex flex-wrap items-center gap-2">
            {actions}
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
};
